import React from 'react';
import classNames from "classnames/bind";

import styles from "./DeficitModal.module.css";

const cx = classNames.bind(styles);

type Props = {
	item: any,
	percent?: number,
	config: {
		color: string,
		text: string,
	}
	handleClose: () => void,
};

export const DeficitModal: React.FC<Props> = ({ item, percent, config, handleClose }) => {
	return (
		<div className={cx("content")}>
			<div className={cx("content_header")}>
				<h3 className={cx("content_title")}>{item.label}</h3>
				<div className={cx("close_button")}>
					<div onClick={handleClose} className={cx("close")} />
				</div>
			</div>
			<div className={cx("description")}>
				<p className={cx("consequences")} dangerouslySetInnerHTML={{ __html: item.influence }}></p>
				<p className={cx("compound")}>
					<span style={{ color: "var(--base_black)" }}>Источники: </span>
					<span dangerouslySetInnerHTML={{ __html: item.sources }}></span>
				</p>
				<div className={cx("info")} style={{ backgroundColor: config.color }}>Дефицит {percent}%</div>
			</div>
		</div>
	);
}